export enum ROLES_ENUM {
  ADMIN = "admin",
  USER = "user",
}
